import { IElectronAPI } from "./index.d";
import { UiStatus } from "./types/UiStatus";

export class UiStatusService {
  private uiStatus: UiStatus;
  private initialGracePeriodMs: number = 20000;
  private initialGracePeriod;
  private electronApi: IElectronAPI;

  constructor(electronApi: IElectronAPI) {
    this.uiStatus = UiStatus.INITIALIZING;
    this.initialGracePeriod = setTimeout(() => {
      this.initialGracePeriodOver();
    }, this.initialGracePeriodMs);
    this.electronApi = electronApi;
  }

  public setStatus(status: UiStatus) {
    this.uiStatus = status;
    if (this.uiStatus === UiStatus.READY) {
      this.sendReadyMessage();
      clearTimeout(this.initialGracePeriod);
    }
  }

  public getStatus(): UiStatus {
    return this.uiStatus;
  }

  private sendReadyMessage() {
    this.electronApi.reactIsReady();
  }

  private sendErrorMessage(errorMessage: string) {
    this.electronApi.reactError(errorMessage);
  }

  private initialGracePeriodOver() {
    if (this.uiStatus === UiStatus.READY) {
      return;
    }
    this.sendErrorMessage("Error: " + this.uiStatus);
  }
}
